var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.permissions),function(permission,index){return _c('div',{key:index},[_c('toggles-section-item',{attrs:{"permission":permission,"user-permissions":_vm.value},on:{"toggle":_vm.onToggle}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }